"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsoPoint = void 0;
const PIXI = __importStar(require("pixi.js"));
const IsometricUtils_1 = require("../isometric/IsometricUtils");
class IsoPoint {
    constructor(x = 0, y = 0, z = 0) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static from(point, copy = true) {
        if (point instanceof IsoPoint)
            return copy ? point.copy() : point;
        if (Array.isArray(point))
            return new IsoPoint(point[0], point[1], point[2]);
    }
    static isIsoPoint(value) {
        return typeof value === 'object' && 'x' in value && 'y' in value && 'z' in value;
    }
    add(xOrPoint = 0, y, z) {
        if (IsoPoint.isIsoPoint(xOrPoint)) {
            this.x += xOrPoint.x;
            this.y += xOrPoint.y;
            this.z += xOrPoint.z;
        }
        else {
            this.x += xOrPoint;
            this.y += y;
            this.z += z;
        }
        return this;
    }
    scale(x = 1, y = x, z = y) {
        this.x *= x;
        this.y *= y;
        this.z *= z;
        return this;
    }
    set(x = 1, y = x, z = y) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    copy() {
        return new IsoPoint(this.x, this.y, this.z);
    }
    applyIn(obj) {
        obj.x = this.x;
        obj.y = this.y;
        obj.z = this.z;
    }
    toPoint() {
        const p = IsometricUtils_1.IsometricUtils.cartToIso(this.x, this.y, this.z);
        return new PIXI.Point(p.x, p.y);
    }
    static fromPoint(point, z = 0) {
        const p = IsometricUtils_1.IsometricUtils.isoToCart(point.x, point.y, z);
        return new IsoPoint(p.x, p.y, z);
    }
}
exports.IsoPoint = IsoPoint;
